import Addteacher from "./components/Addteacher.vue";
import Login from "./components/Login.vue";
import NewStudent from "./components/NewStudent.vue"
import Students from "./components/Students.vue";
import Dashboard from "./components/Dashboard.vue"
import NotFound from "./components/NotFound.vue";
import Teachers from "./components/Teachers.vue";
import Sessions from "./components/Sessions.vue"
import AppSetting from "./components/AppSetting.vue"
import SendMes from "./components/SendMes.vue"
import StudentSessions from "./components/StudentSessions.vue"
import AddAdmin from "./components/AddAdmin.vue"
import AllStudents from "./components/AllStudents.vue"
import AddStudent from "./components/AddStudent.vue"
import AllAdmins   from "./components/AllAdmins.vue"
import SessionReport from "./components/SessionReport.vue"
import SummarySessionReport from "./components/SummarySessionReport.vue"
import DailyStudentReport from "./components/DailyStudentReport.vue"
import TeacherCalendar from "./components/TeacherCalendar.vue"
import StudentCalendar from "./components/StudentCalendar.vue"

import TeacherResponseReport from "./components/TeacherResponseReport.vue"
import Organizations from "./pages/Organizations.vue"

import AdminMessages from "./components/AdminMessages.vue"
import LiveSessions from "./components/LiveSessions.vue"
import StudentSessionsManagement from "./components/StudentSessionsManagement.vue";
import AdminStudentBooking from "./components/AdminStudentBooking.vue";
import SessionTimeManagement from "./components/SessionTimeManagement.vue";
import AdminNotifications from "./components/AdminNotifications.vue"
import AuditLogs from "./components/AuditLogs.vue"
import RecordingsLogs from "./components/RecordingsLogs.vue"
import CallSessionsLogs from "./components/CallSessionsLogs.vue"
import TenantsManagement from "./components/TenantsManagement.vue"
import TenantPaymentGatewaysManagement from "./components/TenantPaymentGatewaysManagement.vue"
import TenantAgoraConfigsManagement from "./components/TenantAgoraConfigsManagement.vue"
import TenantAppUpdateConfigsManagement from "./components/TenantAppUpdateConfigsManagement.vue"
import TenantNativeCallConfigsManagement from "./components/TenantNativeCallConfigsManagement.vue"
import GeneralManagersManagement from "./components/GeneralManagersManagement.vue"
import QualificationsManagement from "./components/QualificationsManagement.vue"
import DurationsManagement from "./components/DurationsManagement.vue"
import MassaratsManagement from "./components/MassaratsManagement.vue"
import RegionsManagement from "./components/RegionsManagement.vue"
import AthanTimesManagement from "./components/AthanTimesManagement.vue"
import GoalsManagement from "./components/GoalsManagement.vue"
import AboutUsManagement from "./components/AboutUsManagement.vue"
import ContactUsManagement from "./components/ContactUsManagement.vue"
import TermsAndConditionsManagement from "./components/TermsAndConditionsManagement.vue"
import TeacherScheduleManagement from "./components/TeacherScheduleManagement.vue"
import PeerReviewReport from "./components/PeerReviewReport.vue"
import SuperAdminGeneralReport from "./components/SuperAdminGeneralReport.vue"
import PermissionGroupsManagement from "./components/PermissionGroupsManagement.vue"
import UserPermissionsManagement from "./components/UserPermissionsManagement.vue"
import SupportTickets from "./components/SupportTickets.vue"
import PublicCirclesManagement from "./components/PublicCirclesManagement.vue"
import PublicCircleAttendanceLogs from "./components/PublicCircleAttendanceLogs.vue"
import PublicCircleDailyChatLogs from "./components/PublicCircleDailyChatLogs.vue"
import IqraSchedulesManagement from "./components/Iqra/IqraSchedulesManagement.vue"
import IqraTeacherWeeklySchedule from "./components/Iqra/IqraTeacherWeeklySchedule.vue"
import IqraStudentWeeklySchedule from "./components/Iqra/IqraStudentWeeklySchedule.vue"
import IqraStudentSlotEnrollmentManagement from "./components/Iqra/IqraStudentSlotEnrollmentManagement.vue"
import IqraStudentSlotEnrollmentSearch from "./components/Iqra/IqraStudentSlotEnrollmentSearch.vue"
import IqraSubscriptionPackagesManagement from "./components/Iqra/IqraSubscriptionPackagesManagement.vue"
import IqraStudentSubscriptionsManagement from "./components/Iqra/IqraStudentSubscriptionsManagement.vue"
import IqraPrayerTimesSyncStatus from "./components/Iqra/IqraPrayerTimesSyncStatus.vue"
import IqraSubstituteSessions from "./components/Iqra/IqraSubstituteSessions.vue"
import IqraAttendanceReport from "./components/Iqra/IqraAttendanceReport.vue"
import IqraTeacherAttendanceReport from "./components/Iqra/IqraTeacherAttendanceReport.vue"
import HafedChat from "./components/HafedChat.vue"
import McpToolPermissionsManagement from "./components/McpToolPermissionsManagement.vue"

import { createRouter, createWebHistory } from 'vue-router'
import axios from 'axios'
import url from '@/url'


const routes = [
    {
        name: 'NotFound',
        path: '/:pathMatch(.*)*',
        component: NotFound,
    },
    {
        name: 'login',
        component: Login,
        path: '/',
        meta: {
            requiresAuth: false,
        },
    },
    {
        name: 'Hafed',
        component: HafedChat,
        path: '/hafed',
        meta: {
            requiresAuth: true,
            pageCode: 'hafed',
        },
    },
    {
        name: 'addteacher',
        component: Addteacher,
        path: '/add/teacher',
        meta: {
            requiresAuth: true,
            pageCode: 'teachers',
        },
    },
    {
        name: 'teachers',
        component: Teachers,
        path: '/view/teachers',
        meta: {
            requiresAuth: true,
            pageCode: 'teachers',
        }
    },
    {
        name: 'newStudent',
        component: NewStudent,
        path: '/new/student',
        meta: {
            requiresAuth: true,
            pageCode: 'new_students',
        },
    },
    {
        name: 'Students',
        component: Students,
        path: '/students',
        meta: {
            requiresAuth: true,
            pageCode: 'students',
        },
    },
    {
        name: 'AddStudent',
        component: AddStudent,
        path: '/add/student',
        meta: {
            requiresAuth: true,
            pageCode: 'students',
        },
    },
    {
        name: 'Dashboard',
        component: Dashboard,
        path: '/dashboard',
        meta: {
            requiresAuth: true,
            pageCode: 'dashboard',
        },
    },
    {
        name: 'Sessions',
        component: Sessions,
        path: '/sessions',
        meta: {
            requiresAuth: true,
            pageCode: 'sessions',
        },
    },
    {
        name: 'AppSetting',
        component: AppSetting,
        path: '/appSetting',
        meta: {
            requiresAuth: true,
            pageCode: 'app_settings',
        },
    },
    {
        name: 'SendMes',
        component: SendMes,
        path: '/sendMes',
        meta: {
            requiresAuth: true,
            pageCode: 'reports',
        },
    },
    {
        name: 'StudentSessions',
        component: StudentSessions,
        path: '/studentSessions',
        meta: {
            requiresAuth: true,
            pageCode: 'iqra_schedules',
        },
    },
    {
        name: 'IqraSubstituteSessions',
        component: IqraSubstituteSessions,
        path: '/iqra/substitute-sessions',
        meta: {
            requiresAuth: true,
            pageCode: 'iqra_schedules',
        },
    },
    {
        name: 'IqraAttendanceReport',
        component: IqraAttendanceReport,
        path: '/iqra/attendance-report',
        meta: {
            requiresAuth: true,
            pageCode: 'iqra_schedules',
        },
    },
    {
        name: 'IqraTeacherAttendanceReport',
        component: IqraTeacherAttendanceReport,
        path: '/iqra/teacher-attendance-report',
        meta: {
            requiresAuth: true,
            pageCode: 'iqra_schedules',
        },
    },
    {
      name: 'AllAdmins',
      component: AllAdmins,
      path: '/allAdmins',
      meta: { 
          requiresAuth: true,
          pageCode: 'admins',
      },
    },
    {
        name: 'SummarySessionReport',
        component: SummarySessionReport,
        path: '/SummarySessionReport',
        meta: { 
            requiresAuth: true,
            pageCode: 'reports',
        },
      },
      {
        name: 'DailyStudentReport',
        component: DailyStudentReport,
        path: '/DailyStudentReport',
        meta: { 
            requiresAuth: true,
            pageCode: 'reports',
        },
      },
      
    {
        name: 'AddAdmin',
        component: AddAdmin,
        path: '/addAdmin',
        meta: {
            requiresAuth: true,
            pageCode: 'admins',
        },
    },
    {
        name: 'AllStudents',
        component: AllStudents,
        path: '/allStudents',
        meta: {
            requiresAuth: true,
            pageCode: 'students',
        },
    },
    {
        name: 'SessionReport',
        component: SessionReport,
        path: '/session-report',
        meta: {
            requiresAuth: true,
            pageCode: 'reports',
        },
    },
    {
        name: 'TeacherCalendar',
        component: TeacherCalendar,
        path: '/teacher-calendar',
        meta: {
            requiresAuth: true,
            pageCode: 'teachers',
        },
    },
    {
        name: 'StudentCalendar',
        component: StudentCalendar,
        path: '/student-calendar',
        meta: {
            requiresAuth: true,
            pageCode: 'students',
        },
    },

    {
        name: 'Organizations',
        component: Organizations,
        path: '/organizations',
        meta: {
            requiresAuth: true,
            pageCode: 'organizations',
        },
    },
    {
        name: 'TeacherResponseReport',
        component: TeacherResponseReport,
        path: '/iqra/teacher-response-report',
        meta: {
            requiresAuth: true,
            pageCode: 'iqra_schedules',
        },
    },

    {
        name: 'AdminMessages',
        component: AdminMessages,
        path: '/admin-messages',
        meta: { 
            requiresAuth: true,
            pageCode: 'admin_messages',
        },
    },
    {
        name: 'LiveSessions',
        component: LiveSessions,
        path: '/live-sessions',
        meta: { 
            requiresAuth: true,
            pageCode: 'iqra_schedules',
        },
    },
    {
        name: 'SessionTimeManagement',
        component: SessionTimeManagement,
        path: '/session-time-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'sessions',
        },
    },
    {
        name: 'StudentSessionsManagement',
        component: StudentSessionsManagement,
        path: '/student-sessions-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'sessions',
        },
    },
    {
        name: 'AdminStudentBooking',
        component: AdminStudentBooking,
        path: '/admin-student-booking',
        meta: {
            requiresAuth: true,
            pageCode: 'sessions',
        },
    },
    {
        name: 'PublicCirclesManagement',
        component: PublicCirclesManagement,
        path: '/public-circles-management',
        meta: {
            requiresAuth: true,
            pageCode: 'public_circles_management',
        },
    },
    {
        name: 'PublicCircleAttendanceLogs',
        component: PublicCircleAttendanceLogs,
        path: '/public-circles-management/attendance-logs',
        meta: {
            requiresAuth: true,
            pageCode: 'public_circles_management',
        },
    },
    {
        name: 'PublicCircleDailyChatLogs',
        component: PublicCircleDailyChatLogs,
        path: '/public-circles-management/daily-chat-logs',
        meta: {
            requiresAuth: true,
            pageCode: 'public_circles_management',
        },
    },
    {
        name: 'AdminNotifications',
        component: AdminNotifications,
        path: '/admin-notifications',
        meta: { 
            requiresAuth: true,
            pageCode: 'admin_notifications',
        },
    },
    {
        name: 'AuditLogs',
        component: AuditLogs,
        path: '/audit-logs',
        meta: {
            requiresAuth: true,
            pageCode: 'audit_logs',
        },
    },
    {
        name: 'RecordingsLogs',
        component: RecordingsLogs,
        path: '/recordings-logs',
        meta: {
            requiresAuth: true,
            pageCode: 'recordings_logs',
        },
    },
    {
        name: 'CallSessionsLogs',
        component: CallSessionsLogs,
        path: '/call-sessions-logs',
        meta: {
            requiresAuth: true,
            pageCode: 'call_sessions_logs',
        },
    },
    {
        name: 'TenantsManagement',
        component: TenantsManagement,
        path: '/tenants-management',
        meta: {
            requiresAuth: true,
            requiresSuperAdmin: true, // Super Admin only - no pageCode needed
        },
    },
    {
        name: 'TenantPaymentGatewaysManagement',
        component: TenantPaymentGatewaysManagement,
        path: '/tenant-payment-gateways',
        meta: {
            requiresAuth: true,
            requiresSuperAdmin: true, // Payment credentials are super-admin scope.
        },
    },
    {
        name: 'TenantAgoraConfigsManagement',
        component: TenantAgoraConfigsManagement,
        path: '/tenant-agora-configs',
        meta: {
            requiresAuth: true,
            requiresSuperAdmin: true, // Agora REST + S3 secrets are super-admin scope.
        },
    },
    {
        name: 'TenantAppUpdateConfigsManagement',
        component: TenantAppUpdateConfigsManagement,
        path: '/tenant-app-update-configs',
        meta: {
            requiresAuth: true,
            // A bad minimum version here locks every user of a branch out of the app.
            requiresSuperAdmin: true,
        },
    },
    {
        name: 'TenantNativeCallConfigsManagement',
        component: TenantNativeCallConfigsManagement,
        path: '/tenant-native-call-configs',
        meta: {
            requiresAuth: true,
            // Enabling this changes how every call on a branch reaches its
            // devices, and it is the kill switch used to roll the feature back.
            requiresSuperAdmin: true,
        },
    },
    {
        name: 'GeneralManagersManagement',
        component: GeneralManagersManagement,
        path: '/general-managers-management',
        meta: { 
            requiresAuth: true,
            requiresSuperAdmin: true, // Super Admin only - no pageCode needed
        },
    },
    {
        name: 'QualificationsManagement',
        component: QualificationsManagement,
        path: '/qualifications-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'qualifications_management',
        },
    },
    {
        name: 'DurationsManagement',
        component: DurationsManagement,
        path: '/durations-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'durations_management',
        },
    },
    {
        name: 'MassaratsManagement',
        component: MassaratsManagement,
        path: '/massarats-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'massarats_management',
        },
    },
    {
        name: 'RegionsManagement',
        component: RegionsManagement,
        path: '/regions-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'regions_management',
        },
    },
    {
        name: 'AthanTimesManagement',
        component: AthanTimesManagement,
        path: '/athan-times-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'athan_times_management',
        },
    },
    {
        name: 'GoalsManagement',
        component: GoalsManagement,
        path: '/goals-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'goals_management',
        },
    },
    {
        name: 'AboutUsManagement',
        component: AboutUsManagement,
        path: '/about-us-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'about_us_management',
        },
    },
    {
        name: 'ContactUsManagement',
        component: ContactUsManagement,
        path: '/contact-us-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'contact_us_management',
        },
    },
    {
        name: 'TermsAndConditionsManagement',
        component: TermsAndConditionsManagement,
        path: '/terms-and-conditions-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'terms_and_conditions_management',
        },
    },
    {
        name: 'TeacherScheduleManagement',
        component: TeacherScheduleManagement,
        path: '/teacher-schedule-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'teachers',
        },
    },
    {
        name: 'PeerReviewReport',
        component: PeerReviewReport,
        path: '/peer-review-report',
        meta: { 
            requiresAuth: true,
            pageCode: 'peer_review_report',
        },
    },
    {
        name: 'SuperAdminGeneralReport',
        component: SuperAdminGeneralReport,
        path: '/super-admin-general-report',
        meta: { 
            requiresAuth: true,
            requiresSuperAdmin: true, // Super Admin only - no pageCode needed
        },
    },
    {
        name: 'PermissionGroupsManagement',
        component: PermissionGroupsManagement,
        path: '/permission-groups',
        meta: {
            requiresAuth: true,
            pageCode: 'permission_groups',
        },
    },
    {
        name: 'UserPermissionsManagement',
        component: UserPermissionsManagement,
        path: '/user-permissions',
        meta: {
            requiresAuth: true,
            pageCode: 'user_permissions',
        },
    },
    {
        name: 'SupportTickets',
        component: SupportTickets,
        path: '/support-tickets',
        meta: {
            requiresAuth: true,
            pageCode: 'support_tickets',
        },
    },
    {
        name: 'IqraSchedulesManagement',
        component: IqraSchedulesManagement,
        path: '/iqra/schedules',
        meta: {
            requiresAuth: true,
            pageCode: 'iqra_schedules',
        },
    },
    {
        name: 'IqraTeacherWeeklySchedule',
        component: IqraTeacherWeeklySchedule,
        path: '/iqra/teacher-weekly-schedule',
        meta: {
            requiresAuth: true,
            pageCode: 'iqra_schedules',
        },
    },
    {
        name: 'IqraStudentWeeklySchedule',
        component: IqraStudentWeeklySchedule,
        path: '/iqra/student-weekly-schedule',
        meta: {
            requiresAuth: true,
            pageCode: 'iqra_schedules',
        },
    },
    {
        name: 'IqraStudentSlotEnrollmentManagement',
        component: IqraStudentSlotEnrollmentManagement,
        path: '/iqra/student-slot-enrollments',
        meta: {
            requiresAuth: true,
            pageCode: 'iqra_schedules',
        },
    },
    {
        name: 'IqraStudentSlotEnrollmentSearch',
        component: IqraStudentSlotEnrollmentSearch,
        path: '/iqra/student-slot-enrollments-search',
        meta: {
            requiresAuth: true,
            pageCode: 'iqra_schedules',
        },
    },
    {
        name: 'IqraSubscriptionPackagesManagement',
        component: IqraSubscriptionPackagesManagement,
        path: '/iqra/subscription-packages',
        meta: {
            requiresAuth: true,
            pageCode: 'iqra_subscription_packages',
        },
    },
    {
        name: 'IqraStudentSubscriptionsManagement',
        component: IqraStudentSubscriptionsManagement,
        path: '/iqra/student-subscriptions',
        meta: {
            requiresAuth: true,
            pageCode: 'iqra_student_subscriptions',
        },
    },
    {
        name: 'IqraPrayerTimesSyncStatus',
        component: IqraPrayerTimesSyncStatus,
        path: '/iqra/prayer-times-sync-status',
        meta: {
            requiresAuth: true,
            pageCode: 'iqra_schedules',
        },
    },
    {
        name: 'McpToolPermissionsManagement',
        component: McpToolPermissionsManagement,
        path: '/ai-tool-permissions',
        meta: {
            requiresAuth: true,
            pageCode: 'mcp_tool_permissions',
        },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

const refreshPermissions = async (token) => {
    if (!token) return null;
    try {
        // This call is awaited inside the router guard, and vue-router will not
        // resolve the navigation until next() runs. Without a timeout a stalled
        // /permissions/me leaves the old view mounted with no spinner and no
        // error — the panel simply appears frozen. On timeout axios rejects,
        // the catch below returns null, and the caller falls back to a
        // deterministic decision.
        const response = await axios.get(
            process.env.VUE_APP_SERVICE_URL + url.permissions_me,
            {
                timeout: 10000,
                headers: {
                    'X-Authorization': token,
                },
            }
        );

        let permissions = null;
        if (response?.data?.result?.data?.permissions) {
            permissions = response.data.result.data.permissions;
        } else if (response?.data?.data?.permissions) {
            permissions = response.data.data.permissions;
        }

        if (permissions && typeof permissions === 'object') {
            localStorage.setItem('permissions', JSON.stringify(permissions));
            return permissions;
        }
    } catch (error) {
        console.error('Error refreshing permissions:', error);
    }
    return null;
};

router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        const token = localStorage.getItem("token");
        if (!token) {
            return next({ name: 'login' });
        }
        let isExpired = false;
        try {
            const { exp } = JSON.parse(atob(token.split('.')[1]));
            if (exp * 1000 < Date.now()) {
                isExpired = true;
            }
        } catch (error) {
            isExpired = true;
        }
        if (isExpired) {
            localStorage.clear();
            return next({ name: 'login' });
        }
        const userRole = localStorage.getItem("userRole");
        if (userRole !== 'ADMIN' && userRole !== 'GENERAL_MANAGER' && userRole !== 'SUPER_ADMIN') {
            localStorage.clear();
            return next({ name: 'login' });
        }

        // Check if route requires Super Admin
        if (to.meta.requiresSuperAdmin) {
            if (userRole !== 'SUPER_ADMIN') {
                // Redirect to dashboard if not Super Admin
                return next({ name: 'Dashboard' });
            }
            // Super Admin has access, skip permission checks
            return next();
        }

        // Check permissions if pageCode is specified in route meta
        // No fallback: page access requires explicit read permission.
        if (to.meta.pageCode) {
            const userRole = localStorage.getItem("userRole");

            // Super Admin bypass
            if (userRole === 'SUPER_ADMIN') {
                return next();
            }

            // An account with no permissions at all cannot use the panel. Send
            // it back to login with a message instead of redirecting to
            // Dashboard — Dashboard is itself a pageCode route, so that would
            // fail the same check and redirect forever, freezing the tab.
            const denyToLogin = () => {
                localStorage.clear();
                return next({ name: 'login', query: { reason: 'no-permissions' } });
            };

            let permissions = null;
            try {
                const storedPermissions = localStorage.getItem('permissions');
                permissions = storedPermissions ? JSON.parse(storedPermissions) : null;
            } catch (error) {
                console.error('Error parsing permissions:', error);
                permissions = null;
            }

            if (!permissions || Object.keys(permissions).length === 0) {
                return denyToLogin();
            }

            let pagePermissions = permissions[to.meta.pageCode];

            if (!pagePermissions || pagePermissions.read !== true) {
                const refreshedPermissions = await refreshPermissions(token);
                pagePermissions = refreshedPermissions?.[to.meta.pageCode];

                if (!pagePermissions || pagePermissions.read !== true) {
                    // Lacking permission for *this* page is fine — fall back to
                    // Dashboard. Lacking it for Dashboard itself is not: there
                    // is nowhere left to send them.
                    if (to.name === 'Dashboard') {
                        return denyToLogin();
                    }
                    return next({ name: 'Dashboard' });
                }
            }
        }

        return next();
    }
    return next();
});

export default router;